import { createClient } from '@supabase/supabase-js'

const SUPABASE_URL = 'https://tyxdvhtydnshvxkjasfn.supabase.co'
const SUPABASE_ANON_KEY = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InR5eGR2aHR5ZG5zaHZ4a2phc2ZuIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NjI5MzY0MzYsImV4cCI6MjA3ODUxMjQzNn0.EVzT-YzOormsSibWkjrWV68KCwYBTds05HuhCXu7bi0'

if(!SUPABASE_URL || !SUPABASE_ANON_KEY ){
  throw new Error('Missing Supabase variables');
}

export default createClient(SUPABASE_URL, SUPABASE_ANON_KEY, {
  auth: {
    persistSession: true,
    autoRefreshToken: true
  }
})